import { FaSearch } from "react-icons/fa";

const FragmentSearch = ({ searchTerm, onChange }) => {
  return (
    <div className="relative">
      <FaSearch className="absolute left-3 top-3 text-gray-400" />
      <input
        type="text"
        placeholder="Search fragments..."
        className="w-full bg-gray-800 p-2 pl-8 rounded text-white"
        value={searchTerm}
        onChange={onChange}
        aria-label="Search fragments"
      />
    </div>
  );
};

export default FragmentSearch;
